<!--
    预约模块
-->
<template>
  <div class="appoint-box">
    <!-- <div v-maidian="'activityRule'" @click="ruleDialog" class="rule-btn">活动规则</div> -->
    <div class="appoint">
      <div class="appoint-tit">
        <img
          src="https://picbed.qunarzz.com/377e9caa5991766c9c0d8e5844fa1c11.png"
          alt=""
        />
      </div>
      <div class="appoint-form">
        <div class="appoint-tip">
          进一步了解林肯的最新动向和未来活动信息？请留下您的资料，一切轻松掌握。（*号为必填项目）
        </div>
        <div class="inp-box-fluid clear">
          <div class="inp-box">
            <p class="inp-tit">姓 <span class="red">*</span></p>
            <input
              v-model="xing"
              maxlength="11"
              class="fullInput mb-normal"
              type="text"
              placeholder="姓"
            />
          </div>
          <div class="inp-box">
            <p class="inp-tit">名 <span class="red">*</span></p>
            <input
              v-model="ming"
              maxlength="3"
              class="fullInput mb-normal"
              type="text"
              placeholder="名"
            />
          </div>
        </div>
        <div class="inp-box-fluid clear">
          <radioComp v-model="sex" :list="sexList"></radioComp>
        </div>
        <div class="inp-box">
          <p class="inp-tit">手机电话 <span class="red">*</span></p>
          <input
            v-model="userPhone"
            maxlength="11"
            class="fullInput mb-normal"
            type="text"
            placeholder="请输入手机号"
          />
        </div>
        <div class="inp-box">
          <p class="inp-tit">车型 <span class="red">*</span></p>
          <select class="fullInput" v-model="carType" name="" id="">
            <option
              v-for="(item, index) in carList"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
        </div>
        <div class="inp-box">
          <p class="inp-tit">所在省份 <span class="red">*</span></p>
          <select
            @change="changeProvince"
            class="fullInput mb-normal"
            v-model="provinceCode"
            name=""
            id=""
          >
            <option
              v-for="(item, index) in provinceList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="inp-box">
          <p class="inp-tit">所在城市 <span class="red">*</span></p>
          <select
            @change="changeCity"
            class="fullInput mb-normal"
            v-model="cityCode"
            name=""
            id=""
          >
            <option
              v-for="(item, index) in cityList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="inp-box">
          <p class="inp-tit">经销商 <span class="red">*</span></p>
          <select class="fullInput" v-model="storeCode" name="" id="">
            <option
              v-for="(item, index) in storeList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="inp-box-fluid clear">
          <p class="inp-tit">购车时间 <span class="red">*</span></p>
          <div class="clear">
            <radioComp v-model="month" :list="monthList"></radioComp>
          </div>
        </div>
        <checkbox v-model="checked"></checkbox>
        <div @click="submit" class="submit">确认提交</div>
      </div>
    </div>
  </div>
</template>
<script>
import checkbox from "./checkbox";
import ruleDialog from "./dialog/rule/index";
import giftDialog from "./dialog/gift/index";
import radioComp from './radio'
export default {
  components: {
    checkbox,
    radioComp
  },
  data() {
    return {
      userName: "",
      userPhone: "",
      storeCode: "",
      carType: "",
      checked: true,
      xing:'',
      ming:'',
      month:'01',
      sex:"先生",
      carList:[{
        value:'',
        label:'请选择'
      },{
        value:'LINKE_202304M',
        modelCode:'ZLM1010',
        modelName:'Corsair',
        label:'冒险家'
      },{
        value:'LINKE_202304Z',
        modelCode:'ZLM1013',
        modelName:'Corsair',
        label:'林肯Z'
      }],
      sexList:[
        {
          label:'先生',
          value:'先生',
          checked:true
        },
        {
          label:'女士',
          value:'女士',
          checked:false
        }
      ],
      monthList:[
        {
          label:'3个月内',
          value:'01',
          checked:true
        },
        {
          label:'4-6个月',
          value:'02',
          checked:false
        },
        {
          label:'7-12个月',
          value:'03',
          checked:false
        },
        {
          label:'1年以上',
          value:'04',
          checked:false
        }
      ],
      infoParams: {
        name: "",
        phone: "",
        vin: "",
      },
      cityCode: "",
      provinceCode: "",
      vehicleKeepInfoKey: "",
      defaultSelect: { name: "请选择", value: "" },
      carSeriesList: [],
      provinceList: [],
      rentalLottery: null,
      cityList: [],
      storeList: [],
    };
  },
  created() {
    this.provinceList = [this.defaultSelect];
    this.carSeriesList = [{ name: "请选择车型", value: "" }];
    this.cityList = [this.defaultSelect];
    this.storeList = [{ name: "请选择经销商", value: "" }];
    this.initProvinceList();
  },
  methods: {
    ruleDialog() {
      ruleDialog();
    },
    getCarRentalCouponsList() {
      this.$axios.get("/geely/getCarRentalCouponsList").then((res) => {
        if (res.code == 200) {
          if (res.data.length) {
            this.rentalLottery = true;
          } else {
            this.rentalLottery = false;
          }
        } else if (res.code == 400) {
          loginDialog({
            userPhone: this.userPhone,
            callback: () => {
              this.getCarRentalCouponsList();
            },
          });
          this.rentalLottery = false;
        } else {
          this.$dialog.alert({
            message: res.message,
          });
        }
      });
    },
    lotteryAndReceive() {
      if (this.rentalLottery) return;
      this.$axios.post("/geely/lotteryAndReceive").then((res) => {
        if (res.code == 200) {
          this.getCarRentalCouponsList();
        } else if (res.code == 400) {
          loginDialog({
            userPhone: this.userPhone,
            callback: () => {
              this.lotteryAndReceive();
            },
          });
        } else {
          if (res.message == "今日奖品已发完") {
            giftDialog({
              giftTip: "NO_AWARD",
            });
          } else {
            this.$dialog.alert({
              message: res.message,
            });
          }
        }
      });
    },
    changeSeries(e) {
      // this.provinceCode = "";
      // this.cityCode = "";
      this.storeCode = "";
      this.carType = e.target.value;
    },
    verifyForm() {
      return new Promise((resolve) => {
        var reg = /^1[3456789]\d{9}$/gi;
        var regName = /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/;
        let dialog = this.$dialog;
        if (!this.checked) {
          dialog.alert({
            message: "请勾选免责声明",
          });
        } else if (this.xing == "") {
          dialog.alert({
            message: "请输入姓",
          });
        } else if(!regName.test(this.xing)){
          dialog.alert({
            message: "姓不能含有特殊字符或空格",
          });
        } else if (this.ming == "") {
          dialog.alert({
            message: "请输入名",
          });
        }else if(!regName.test(this.ming)){
          dialog.alert({
            message: "名不能含有特殊字符或空格",
          });
        } else if (this.carType == "") {
          dialog.alert({
            message: "请输入车型",
          });
        } else if (this.userPhone == "") {
          dialog.alert({
            message: "请输入手机号",
          });
        } else if (!reg.test(this.userPhone)) {
          dialog.alert({
            message: "请输入正确的手机号",
          });
        } else if (!this.provinceCode) {
          dialog.alert({
            message: "请选择省份",
          });
        } else if (!this.cityCode) {
          dialog.alert({
            message: "请选择城市",
          });
        } else if (!this.storeCode) {
          dialog.alert({
            message: "请选择经销商",
          });
        } else {
          resolve();
        }
      });
    },
    verifyCarForm() {
      return new Promise((resolve) => {
        var reg = /^1[3456789]\d{9}$/gi;
        let dialog = this.$dialog;
        if (this.infoParams.name == "") {
          dialog.alert({
            message: "请输入姓名",
          });
        } else if (this.infoParams.phone == "") {
          dialog.alert({
            message: "请输入手机号",
          });
        } else if (!reg.test(this.infoParams.phone)) {
          dialog.alert({
            message: "请输入正确的手机号",
          });
        } else if (this.infoParams.vin == "") {
          dialog.alert({
            message: "请输入vin",
          });
        } else {
          resolve();
        }
      });
    },
    submitCarForm() {
      this.verifyCarForm().then(() => {
        this.$axios.post("/userop/commit", this.infoParams).then((res) => {
          if (res.code == 200) {
            giftDialog({
              giftTip: "VIP_SUBMIT",
            });
          } else if (res.code == 400) {
            loginDialog({
              userPhone: this.userPhone,
              callback: () => {
                this.submitCarForm();
              },
            });
          } else {
            this.$dialog.alert({
              message: res.message,
            });
          }
        });
      });
    },
    submit() {
      this.verifyForm().then(() => {
        let item = this.carList.filter((item)=>{
          if(item.value == this.carType){
            return item;
          }else{
            return false;
          }
        })[0]
        let params = {
          province: this.provinceCode,
          sex: this.sex,
          city: this.cityCode,
          phone: this.userPhone,
          name: this.xing,
          reputation:this.ming,
          modelCode : item.modelCode,
          modelName : item.modelName,
          carTime:this.month,
          agent: this.storeCode,
        };
        this.$axios.post("/lincolnDmsThird/keepInfo", params).then((res) => {
          if (res.code == 200) {
            // giftDialog();
            this.$dialog.alert({
              message: '留资成功',
            });
          } else {
            this.$dialog.alert({
              message: res.message,
            });
          }
        });
      });
    },
    initCarSeriesList() {
      this.$axios.get("/keepInfo/model").then((res) => {
        let carSeriesList = [{ name: "请选择车型", value: "" }];
        res.data.forEach((item) => {
          carSeriesList.push({
            name: item.modelName,
            value: item.modelName,
            modelCode: item.modelCode,
          });
        });
        this.carSeriesList = carSeriesList;
      });
    },
    initProvinceList() {
      this.$axios.get("/keepInfo/provinces").then((res) => {
        let provinceList = [this.defaultSelect];
        res.data.forEach((item) => {
          provinceList.push({
            name: item,
            value: item,
          });
        });
        this.provinceList = provinceList;
      });
    },
    filterCode() {
      let code = "";
      this.carSeriesList.forEach((item, index) => {
        if (item.name == this.carType) {
          code = item.modelCode;
        }
      });
      return code;
    },
    initCityList(province) {
      this.$axios.get("/keepInfo/cities?province=" + province).then((res) => {
        let cityList = [this.defaultSelect];
        res.data.forEach((item) => {
          cityList.push({
            name: item,
            value: item,
          });
        });
        this.cityList = cityList;
      });
    },
    initStoreList(provinceCode, cityCode) {
      this.$axios
        .get("/keepInfo/agents?province=" + provinceCode + "&city=" + cityCode)
        .then((res) => {
          let storeList = [{ name: "请选择经销商", value: "" }];
          res.data.forEach((item) => {
            storeList.push({
              name: item,
              value: item,
            });
          });
          this.storeList = storeList;
        });
    },
    changeProvince(e) {
      this.cityCode = "";
      this.storeCode = "";
      this.provinceCode = e.target.value;
      this.initCityList(this.provinceCode);
    },
    changeCity(e) {
      this.storeCode = "";
      this.cityCode = e.target.value;
      this.initStoreList(this.provinceCode,this.cityCode);
    },
  },
};
</script>
<style lang="less" scoped>
.red{
  color:#aa6c41;
}
.appoint {
  width: calc(100% - 30px);
  margin-left: auto;
  margin-right: auto;
  position: relative;
  background-color:#fff;
  z-index:2;
  padding-bottom:18px;
  .inp-tit {
    height: 25px;
    line-height: 25px;
    text-align: left;
  }
  &-form {
    padding-left: 10px;
    padding-right: 10px;
  }
  &-tip {
    padding: 5px 0;
  }
  .inp-box-fluid {
    .inp-box {
      float: left;
      width: calc(50% - 10px);
    }
  }
  input[type='radio']{
    margin:0;
    margin-right: 8px;
    width:14px;
    height:14px;
  }
  .inp-box {
    text-align: left;
    box-sizing: border-box;
    input {
      width: 100%;
      box-sizing: border-box;
      border: 1px solid #dfdfdf;
      -webkit-appearance: none;
      outline: none;
      height: 30px;
      padding-left: 20px;
    }
    select,
    option {
      width: 100%;
      box-sizing: border-box;
      border: 1px solid #dfdfdf;
      outline: none;
      height: 30px;
      padding-left: 20px;
      -webkit-appearance: none;
      background-color: #fff;
    }
    &:nth-child(2) {
      margin-left: 20px;
    }
  }
  .inp-check-box {
    float: left;
    text-align: left;
    width: 50%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .inp-check-box-sm{
    float: left;
    text-align: left;
    width:auto;
    margin-right:8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0;
    padding-bottom: 0;
  }
  .submit{
    width:298px;
    background-color: #bc7031;
    color:#fff;
    border-radius: 5px;
    cursor: pointer;
    margin-left:auto;
    margin-right:auto;
    text-align: center;
    line-height: 38px;
  }
}
</style>